import { createApp } from 'vue'
import App from './App.vue'
// import './registerServiceWorker'
import router from './router'
import { vMaska } from "maska/vue"

import 'bootstrap/dist/js/bootstrap'
import './custom.scss'

// Vue.config.productionTip = false // Not needed in Vue 3

if (process.env.NODE_ENV !== 'development' && window.location.origin.split('://')[0] === 'http' && window.location.hostname !== "localhost") {
  var httpURL = window.location.hostname + window.location.pathname + window.location.search;
  var httpsURL = "https://" + httpURL;
  window.location = httpsURL;
}

const app = createApp(App)

app.use(router)
app.directive("mask", vMaska)

app.mount('#app')
